/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum VaultedInterrogatoryUsageType {
    UseObjections = 0,
    UseResponse = 1
}

export function VaultedInterrogatoryUsageTypeFromJSON(json: any): VaultedInterrogatoryUsageType {
    return VaultedInterrogatoryUsageTypeFromJSONTyped(json, false);
}

export function VaultedInterrogatoryUsageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultedInterrogatoryUsageType {
    return json as VaultedInterrogatoryUsageType;
}

export function VaultedInterrogatoryUsageTypeToJSON(value?: VaultedInterrogatoryUsageType | null): any {
    return value as any;
}

